import {connect} from "react-redux";
import {CSSProperties} from "react";
import {List, ListItem} from "material-ui/List";
import Divider from "material-ui/Divider";
import {Link} from "react-router";

import LayoutWithAppBar from "src/components/LayoutWithAppBar";
import SecondaryAppBar from "src/components/SecondaryAppBar";
import {Text} from "src/components/translation";
import {prepareStyles} from "src/utils/components";

import {logoutClicked} from "./Sidebar.actions";


const styles = prepareStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
});

interface SidebarProps {
  style?: CSSProperties;
}

const Sidebar = connect(
  (state: any, props: SidebarProps) => ({}),
  {
    handleLogoutClick() {
      return logoutClicked();
    },
  },
)(({
  style,
  handleLogoutClick,
}) => {
  const appBar = <SecondaryAppBar showMenuIconButton={false}
                                  title={<Text>Identity</Text>}/>;

  return <LayoutWithAppBar style={style} appBarElement={appBar}>
    <div style={styles.root}>
      <List>
        <ListItem primaryText="Projects"
                  containerElement={<Link to="/projects"/>}/>
        <ListItem primaryText="Users"
                  containerElement={<Link to="/users"/>}/>
      </List>

      <List>
        <Divider/>
        <ListItem primaryText="Log Out" onTouchTap={handleLogoutClick}/>
      </List>
    </div>
  </LayoutWithAppBar>;
});

export default Sidebar;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/Sidebar.tsx